import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { getItemsIds } from '../../../../../utils/common'
import { Field } from '../../../../Field'
import { FileList, FilePreview } from '../../../../File'

import * as styles from './DocFlowFormFilesField.module.css'

function DocFlowFormFilesField({
  files,
  filesError,
  filesUploading,
  onExcludeFile,
  onRemoveFile,
}) {
  const { t } = useTranslation()

  const { isSubmitting } = useFormikContext()

  function handleDeleteFile(id) {
    if (getItemsIds(files)?.includes(id)) {
      onExcludeFile(id)
    } else {
      onRemoveFile(id)
    }
  }

  function renderFile(file, key) {
    return <FilePreview file={file} key={key} onRemoveFile={handleDeleteFile} />
  }

  return (
    <Field
      shouldAdaptToMobileScreen
      disabled={isSubmitting}
      label={`${t('DocumentStapling.FormAttachLabelKey')}:`}
    >
      <FileList
        className={styles.files}
        errorItems={filesError}
        files={files}
        renderItem={renderFile}
        uploadingItems={filesUploading}
        onRemoveFile={onRemoveFile}
      />
    </Field>
  )
}

export default DocFlowFormFilesField
